<script setup>
  import { useSlots } from 'vue'

  defineProps(['label', 'value', 'vertical', 'isRequired'])

  const slots = useSlots()
  const hasDefaultSlot = slots.default !== undefined
</script>

<template>
  <div class="key-value" :class="{ vertical }">
    <div class="key">
      {{ $te(label) ? $t(label) : label }}
      <span v-if="isRequired" class="text-required">*</span>
    </div>
    <div class="value">
      <slot v-if="hasDefaultSlot" />
      <div v-else>{{ value }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .key-value {
    display: flex;
    flex-direction: row;
  }

  .key {
    font-weight: bold;
    min-width: 200px;
  }

  .vertical {
    flex-direction: column;
  }

  .value {
    width: 100%;
  }

  .text-required {
    color: var(--fm-ui-red-color);
  }

  @include breakpoint('tablet') {
    .key-value {
      flex-direction: column;
    }
  }
</style>
